import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {RoadtripListPageModule} from '../roadtrip-list/roadtrip-list.module';
import {MyRoutesPage} from './my-routes';

@NgModule({
  declarations: [
    MyRoutesPage,
  ],
  exports: [
    MyRoutesPage
  ],
 
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    RouterModule,
    RoadtripListPageModule
  ]
})
export class MyRoutesPageModule {
}
